import { useMutation } from '@tanstack/react-query';

import { saveGlobalLetter } from '../api';

import { useResetGlobalLetter } from './use-reset-global-letter';

export const useSaveGlobalLetter = () => {
  const resetGlobalLetter = useResetGlobalLetter();
  return useMutation({
    mutationFn: saveGlobalLetter,
    onSuccess: (_data) => {
      resetGlobalLetter();
    },
    onError: (_error) => {},
  });
};
